import { render, staticRenderFns } from "./select-animation.vue?vue&type=template&id=605f09ca&scoped=true&"
import script from "./select-animation.vue?vue&type=script&lang=ts&"
export * from "./select-animation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605f09ca",
  null
  
)

export default component.exports